import { createRouter, createWebHistory } from 'vue-router';
import { hasPendingHomeSectionScroll } from '@/composables/useHomeSectionNav.js';
import HomeView from '@/views/home/index.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    // 首页锚点由 HomeView 自行处理（含跨页 pending hash）
    if (to.name === 'home' && (to.hash || hasPendingHomeSectionScroll())) {
      return false;
    }
    return { top: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index.vue'),
    },
    {
      path: '/cases',
      name: 'cases',
      component: () => import('@/views/cases/index.vue'),
    },
    {
      path: '/updates',
      name: 'updates',
      component: () => import('@/views/updates/index.vue'),
    },
    {
      path: '/legal',
      redirect: '/legal/privacy',
    },
    {
      path: '/legal/:doc(privacy|terms)',
      name: 'legal',
      component: () => import('@/views/legal/index.vue'),
      meta: { hideFooter: true },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFound.vue'),
    },
  ],
});

export default router;
